
import { defineComponent } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";

import { useStore } from "vuex";

import GetSekolah from "@/components/1crm/fitur/management-fitur-sekolah/index.vue";

export default defineComponent({
  name: "Detail Sekolah",
  components: {
    GetSekolah,
  },
  props: {
    widgetClasses: String,
  },

  beforeMount() {
    const store = useStore();
    store.dispatch(Actions.VERIFY_AUTH_SEKOLAH);
    setCurrentPageBreadcrumbs("Management All Fitur Per Sekolah", ["Management Fitur"]);
  },
});
